module.exports = __webpack_public_path__ + "static/img/conveyor-belt-mk-3_256.5c3c03c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-belt-mk-3_256.png
// module id = FPOc
// module chunks = 0